export default {"src":"/_next/static/media/bay.3994a035.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};